import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";

function Service() {
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServiceData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch("https://backend.ohanyanlegal.am/688787d8ff144c502c7/api/services/page/");
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        setServiceData(data);
      } catch (error) {
        console.error("Fetch error:", error);
        setError("Failed to load services page");
      } finally {
        setLoading(false);
      }
    };

    fetchServiceData();
  }, []);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
  }, []);

  if (loading) {
    return (
      <div>
        <Preloader />
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading services...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Preloader />
        <div className="text-center py-5">
          <p className="text-danger">Error: {error}</p>
          <button 
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  const pageData = serviceData || {};
  const services = pageData.services || [];

  return (
    <div>
      <Preloader />
      <div
        className="breadcrumb-section bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: `url(${pageData.hero_background || 'assets/img/bg-img/73.jpg'})` }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              {pageData.hero_title || "Our Services"}
            </h2>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      <div className="service-container bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4">
            {services.map((service, index) => (
              <div key={service.id || index} className="col-12 col-sm-6 col-xl-3">
                <div
                  className="service-card style-two wow fadeInUp"
                  data-wow-delay={`${300 + index * 100}ms`}
                  data-wow-duration="1000ms"
                >
                  {service.image && (
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="services-up-image"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                  <div className="service-title">{service.title}</div>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="divider"></div>
      </div>

      <ScrollToTop />
    </div>
  );
}

export default Service;